import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/react-sweet-alert
// https://www.npmjs.com/package/react-bootstrap-sweetalert
// import ReactBSAlert from "react-bootstrap-sweetalert";

// Toast functions
export const showSimpleToast = (message) => {
  toast(message);
};

export const showSuccessToast = (message) => {
  toast.success(message);
};

export const showErrorToast = (message) => {
  toast.error(message);
};

export const showInfoToast = (message) => {
  toast.info(message);
};

export const showWarningToast = (message) => {
  toast.warning(message);
};

// Replace AlertModal component with toast-based implementation
export const AlertModal = ({ title, children, onConfirm, ...rest }) => {
  // Show toast and execute onConfirm callback if provided
  React.useEffect(() => {
    if (title || children) {
      const message = (
        <div>
          {title && <strong>{title}</strong>}
          {children && <div>{children}</div>}
        </div>
      );
      
      toast.info(message, {
        onClose: () => {
          if (onConfirm && typeof onConfirm === 'function') {
            onConfirm();
          }
        }
      });
    }
  }, [title, children, onConfirm]);
  
  // Component doesn't render anything, only shows toast notification
  return null;
};

AlertModal.propTypes = {
  title: PropTypes.string,
  onConfirm: PropTypes.func,
  // Keep old props for compatibility, even though they are not used
  cancelBtnText: PropTypes.string,
  confirmBtnText: PropTypes.string,
  onCancel: PropTypes.func,
  showCancel: PropTypes.bool,
  showCloseButton: PropTypes.bool,
};

AlertModal.defaultProps = {
  cancelBtnText: "Cancel",
  confirmBtnText: "OK",
  showCancel: false,
  showCloseButton: false,
};

/*
Example

import AlertModal from "stories/components"
const [infoAlert, setInfoAlert] = useState();
  
const handleModalConfirm = () => {
  setInfoAlert(null);
}

setInfoAlert(
  <AlertModal
    title="Lähetetty"
    onConfirm={() => handleModalConfirm()}
    onCancel={() => handleModalConfirm()}
  >
    Kutsu lähetetty onnistuneesti
  </AlertModal>
)

return (
  <>
  OTHER CONTENT
  {infoAlert}
  </>
)
*/